import * as Yup from 'yup';

export const addSchema = Yup.object().shape({
  activityName: Yup.string()
    .min(4, 'El nombre es muy corto.')
    .max(128, 'El nombre es muy largo.')
    .uppercase()
    .trim()
    .required('Favor de ingresar el nombre.'),
  area: Yup.object().required('Favor de seleccionar el área.'),
  isProductive: Yup.bool().required(),
});

export const editSchema = Yup.object().shape({
  activityName: Yup.string()
    .min(4, 'El nombre es muy corto.')
    .max(128, 'El nombre es muy largo.')
    .uppercase()
    .trim()
    .required('Favor de ingresar el nombre.'),
  area: Yup.object().required('Favor de seleccionar el área.'),
  isProductive: Yup.bool().required(),
  isActive: Yup.bool().required(),
});
